import { render } from "./MandateConformityBanner.vue?vue&type=template&id=97d5227a&scoped=true"
import script from "./MandateConformityBanner.vue?vue&type=script&lang=js"
export * from "./MandateConformityBanner.vue?vue&type=script&lang=js"

import "./MandateConformityBanner.vue?vue&type=style&index=0&id=97d5227a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d5227a"]])

export default __exports__